import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators'
import { Action, Store } from '@ngrx/store';
import { EMPTY, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { SettingsService } from '../settings/settings.service';
import * as fromRoot from '../reducers';
import * as settings from '../actions/settings';

@Injectable()
export class SettingsEffects {
  // No longer triggered off USER_DATA_FOUND: UserService.setupUser() fetches settings
  // itself before the initial location is picked and dispatches LoadSettingsSuccessAction
  // directly. Triggering a second fetch here raced with an early "Set as Default" save -
  // whichever GET resolved last could silently overwrite the just-saved value. Settings
  // are still (re)loaded on demand by settings.component.ts when the Settings page opens.
  public loadSettings$: Observable<Action> = createEffect(() => { return this.actions$.pipe(
    ofType(settings.ActionTypes.LOAD_SETTINGS),
    concatLatestFrom(() => this.store),
    switchMap(([action, state]) => {
      const userName = state.user.userName;
      if (!userName) {
        return EMPTY;
      }
      return this.ss.loadUserSettings(userName).pipe(
        map((responseSettings: any) => {
          const normalizedResponse = responseSettings && typeof responseSettings === 'object' && !Array.isArray(responseSettings)
            ? responseSettings
            : {};
          return new settings.LoadSettingsSuccessAction(normalizedResponse);
        })
      );
    })
  )})

  public saveFavoriteLocations$: Observable<Action> = createEffect(() => { return this.actions$.pipe(
    ofType(settings.ActionTypes.SAVE_USER_SETTINGS, settings.ActionTypes.SAVE_FAVORITE_LOCATIONS),
    map((action: any) => action.payload),
    concatLatestFrom(() => this.store),
    switchMap(([payload, state]) => {
      const { user } = state;
      if (!user.userName) {
        return EMPTY;
      }

      return this.ss.saveUserSettings(
        payload,
        user
      ).pipe(
        map((responseSettings: any) => {
          const normalizedResponse = responseSettings && typeof responseSettings === 'object' && !Array.isArray(responseSettings)
            ? responseSettings
            : {};

          return new settings.FavoriteLocationsUpdatedAction({
            ...user.userSettings,
            ...payload,
            ...normalizedResponse
          });
        })
      );
    })
  )})

  constructor(
    private actions$: Actions,
    private ss: SettingsService,
    private store: Store<fromRoot.State>
  ) { }
}
